module.exports = __webpack_public_path__ + "img/artboard–1.fc36f75b.png";